export const COMPLETE = 'COMPLETE'
export const INCOMPLETE = 'INCOMPLETE'
export const PENDING = 'PENDING'
export const ACTIVE = 'ACTIVE'
export const DRAFT = 'DRAFT'
